/**
 * useRequestTrackerTier
 *
 * Resolves the currently-authenticated user's request-tracker TIER from the
 * whitelist in `@aiga/app-config/security` (the same lists the backend
 * transition gate + client-visibility filter read, with the API's env
 * override on top). Returns 'dev' | 'client' | null.
 *
 * Used to gate the sidebar Request Tracker entry and the /request-tracker
 * route. `null` means the user is on neither list (today the CLIENT list is
 * empty, so only DEV/AIG resolve non-null). Mirrors useIsSuperAdmin so
 * visibility and authorization can't diverge.
 */

import { useAuth } from '../contexts/AuthContext';
import {
  requestTrackerTier,
  type RequestTrackerTier,
} from '@aiga/app-config/security';

export function useRequestTrackerTier(): RequestTrackerTier {
  const { user } = useAuth();
  return requestTrackerTier(user?.email);
}
